var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-2 border-t-2 border-gray-200 leading-relaxed"},[_c('div',{staticClass:"font-bold pb-4"},[_vm._v(_vm._s(_vm.title))]),_vm._t("default",function(){return [_vm._v(_vm._s(_vm.content))]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }